"use client";
import React from "react";
import Link from "./webflow_modules/Basic/components/Link";

export function SearchModalResultItem({ text = "Market Name, State" }) {
  return (
    <Link
      button={true}
      className={"search-modal-result"}
      options={{
        href: "#",
      }}
    >
      {text}
    </Link>
  );
}
